
const it = {
    optional: {
        list: 'Elenco Accessori',
        name: 'Nome {optionalType}',
        code: 'Codice',
        showDetail: 'Dettagli',
        mutateSubtitle: 'Modifica Accessorio',
        shortDescription: 'Descrizione Breve',
        description: 'Descrizione',
        thumbnail: 'Miniatura',
        selectOptional: 'Seleziona ',
        image: 'Immagine',
        group: 'Gruppo {optionalType}',
        optionalType: {
            label: 'Tipo Accessorio',
            APERTURA: 'Soluzione di Apertura/N° Ante',
            CHIUSURA: 'Soluzione di Chiusura',
            CHIUSURA_INFERIORE: 'Chiusura Inferiore',
            CHIUSURA_SUPERIORE: 'Chiusura Superiore',
            APPLICAZIONE: 'Applicazione laterale',
            DOGA: 'Doga',
            FERRAMENTA_SOSTEGNO_ESTERNA: 'Ferramenta Sostegno Esterna',
            //FERRAMENTA_SOSTEGNO_INTERNA: 'Ferramenta Sostegno Interna',
            ALTEZZA_POSIZIONAMENTO: 'Altezza Posizionamento',
            FERMASCURI: 'Fermascuro',
            CARDINI: 'Cardine',
            BANDELLE: 'Bandella',
            BORDO: 'Contorno Foro',
            CONTROTELAIO: 'Controtelaio',
            MURATURA: 'Marmo',
            PANTONE: 'Pantone',
            COLOR: 'Colore',
            TELAIO: 'Tipologia',
            BATTUTA: 'Battuta',
            PAREGGIATORE: 'Pareggiatore',
            SPALLA: 'Spalla',
            //OTHER: 'Altro',
            SIDE4: '4° Lato',
            SEZIONE_MURO: 'Sezione Muro',
            SOLUZIONE_CHIUSURA_SERRATURA: 'Soluzione di Chiusura con Serratura',
            NONE: 'Non definito'


        },
        tabName: {
            APERTURA: '@:optional.optionalType.APERTURA',
            CHIUSURA: '@:optional.optionalType.CHIUSURA',
            CHIUSURA_INFERIORE: '@:optional.optionalType.CHIUSURA_INFERIORE',
            CHIUSURA_SUPERIORE: '@:optional.optionalType.CHIUSURA_SUPERIORE',
            APPLICAZIONE: '@:optional.optionalType.APPLICAZIONE',
            DOGA: '@:optional.optionalType.DOGA',
            FERRAMENTA_SOSTEGNO_ESTERNA: '@:optional.optionalType.FERRAMENTA_SOSTEGNO_ESTERNA',
            //FERRAMENTA_SOSTEGNO_INTERNA: 'Ferramenta Sostegno Interna',
            ALTEZZA_POSIZIONAMENTO: '@:optional.optionalType.ALTEZZA_POSIZIONAMENTO',
            FERMASCURI: '@:optional.optionalType.FERMASCURI',
            CARDINI: '@:optional.optionalType.CARDINI',
            BANDELLE: '@:optional.optionalType.BANDELLE',
            BORDO: '@:optional.optionalType.BORDO',
            CONTROTELAIO: '@:optional.optionalType.CONTROTELAIO',
            MURATURA: '@:optional.optionalType.MURATURA',
            PANTONE: '@:optional.optionalType.PANTONE',
            COLOR: '@:optional.optionalType.COLOR',
            TELAIO: '@:optional.optionalType.TELAIO',
            BATTUTA: '@:optional.optionalType.BATTUTA',
            PAREGGIATORE: '@:optional.optionalType.PAREGGIATORE',
            SPALLA: '@:optional.optionalType.SPALLA',
            SEZIONE_MURO: '@:optional.optionalType.SEZIONE_MURO',
            SIDE4: '@:optional.optionalType.SIDE4',
            SOLUZIONE_CHIUSURA_SERRATURA: '@:optional.optionalType.SOLUZIONE_CHIUSURA_SERRATURA',

        },

    },
    optionalDetail: {
        list: 'Elenco Dettagli {optionalName}',
        listOptionalDetail: 'Elenco Dettagli',
        selectOptionalDetail: 'Seleziona Dettaglio',
        name: 'Nome {optionalType}',
        code: 'Codice',
        orderIdx: 'Ordine',
        mutateSubtitle: 'Modifica Dettaglio {optionalType}',
        description: 'Descrizione',
        shortDescription: 'Descrizione Breve',
        showSolution: 'Mostra soluzioni',
        thumbnail: 'Miniatura',
        image: 'Immagine',
        showCount: 'Richiedi quantità',
        minCount: 'Quantità Minima',
        maxCount: 'Quantità Massima',
        sasheCount: 'Numero Ante',
        count: 'Quantità',
        price: 'Prezzo',
        totalCount: 'Quantità Totale per {count} posizioni',
        allowManualInput: 'Consenti Inserimento Manuale',
        manualInput: 'Inserimento Manuale',
        defaultValue: 'Valore Predefinito',
        axisMin: 'Larghezza minima',
        axisMax: 'Larghezza massima',
        linkingType: 'Collega {optionalTypeFrom} a {optionalTypeTo}',
        inputTypeLabel: 'Nome Campo',
        side: {
            label: 'Apertura anta primaria',
            NONE: 'Non definito',
            LEFT: 'Sinistra',
            RIGHT: 'Destra',
            BOTH: 'Entrambe',
            TOP: 'Alto',
            BOTTOM: 'Basso',
            errorSideRequired: 'Lato apertura obbligatorio',
        },
        inputType: {
            label: 'Tipo di input',
            TEXT: 'Testo',
            TEXTMANDATORY: 'Testo (obbligatorio)',
            NUMBER: 'Numero',
            NUMBERMANDATORY: 'Numero (obbligatorio)',
            MEASURE: 'Misura',
            MEASUREMANDATORY: 'Misura (obbligatorio)',
            QUANTITY: 'Quantità',
            QUANTITYMANDATORY: 'Quantità (obbligatorio)',
            //
            CURRENCY: 'Valuta',
            DATE: 'Data',
            noneSelected: 'Nessun tipo selezionato',
            NONE: 'Non definito (non consente input)'
        },
        showInQuote: 'Mostra l\'opzione ANCHE nei preventivi',
    },
    accessory: {
        list: 'Elenco Accessori di Posa',
        tabName: {
            POSA: 'Accessori di Posa'
        },
        accessoryType: {
            label: 'Tipo Accessorio di Posa',
            NONE: 'Non definito',
            POSA: 'Accessorio di Posa',
            OTHER: 'Altro',
        },
        name: 'Nome Accessorio',
        code: 'Codice',
        showDetail: 'Dettagli',
        mutateSubtitle: 'Modifica Accessorio di Posa',
        shortDescription: 'Descrizione Breve',
        description: 'Descrizione',
        thumbnail: 'Miniatura',
        selectAccessory: 'Seleziona Accessorio',
        image: 'Immagine',
        minQuantity: 'Quantità Minima',
        maxQuantity: 'Quantità Massima',
        unitPrice: 'Prezzo Unitario',
        couldBeDiscounted: 'Applica Sconto',
        orderIdx: 'Ordine',

    }

}
export default it